// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"8664b258","262":"c8a7b872","536":"8c52b0da"}[chunkId] + ".chunk.css";
};